import { useSearchParams } from "react-router-dom";
export function useRotation() {
  const [searchParams] = useSearchParams();
  const rotation = searchParams.get("rotate");
  return rotation;
}
